import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useVehicleCount } from "@cinch-nx/search-shared";
import { FullWidthCTA } from "@cinch-nx/landing-ui-shared";
import { StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import { Head } from "@cinch-nx/landing-ui-shared";
import { storyblokComponents } from "./data/storyblok-renderer-map";
import styles from "./seo-page.module.css";
export var SEOPageFeature = function(param) {
    var story = param.story;
    var ref;
    var content = _object_spread({}, story === null || story === void 0 ? void 0 : story.content);
    var typedContent = content;
    var SEO = typedContent === null || typedContent === void 0 ? void 0 : (ref = typedContent["SEO"]) === null || ref === void 0 ? void 0 : ref[0];
    var vehicleCount = useVehicleCount().vehicleCount;
    var router = useRouter();
    var numberOfCars = new Intl.NumberFormat("en-GB").format(vehicleCount !== null && vehicleCount !== void 0 ? vehicleCount : 0);
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function() {
        trackEvent({
            eventName: "Abandoned Landing page - click search all cars button",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "button",
                    label: "browse all cars",
                    action: "footer"
                }
            }
        });
        router.push("/used-cars");
    };
    var limitedItems = {
        FaqSection: 1
    };
    var wrappedComponents = typedContent.body.map(function(el) {
        return el.component;
    }).filter(function(el) {
        return el !== "FeatureSection";
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, _object_spread_props(_object_spread({}, SEO), {
                fallbackTitle: (story === null || story === void 0 ? void 0 : story.slug) ? story === null || story === void 0 ? void 0 : story.slug : "Cinch Used Cars Article",
                fallbackDescription: "Cinch Used Cars"
            })),
            /*#__PURE__*/ _jsxs("article", {
                className: styles.mainSection,
                "data-testid": "seo-page",
                children: [
                    typedContent && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                        block: typedContent.body,
                        limitedItems: limitedItems,
                        componentsWithWrapper: wrappedComponents,
                        components: storyblokComponents
                    }),
                    /*#__PURE__*/ _jsx(FullWidthCTA, {
                        iconName: "search",
                        iconGradient: "galaxy",
                        iconSize: 41,
                        title: "Let’s find your next car",
                        subtitle: "Ready to hit the open road?",
                        buttonLabel: "Search all ".concat(numberOfCars, " cars"),
                        className: styles.cta,
                        onButtonClick: handleClick,
                        img: {
                            src: "https://a.storyblok.com/f/132543/1054x407/a30d43e649/about-us-civic.png/m/871x0",
                            alt: "Side view of a Honda Civic",
                            width: 871,
                            height: 336
                        }
                    })
                ]
            })
        ]
    });
};
